export default "__VITE_ASSET__66f42922__"